import Model from 'flarum/common/Model';
export default class CustomTabItem extends Model {
  label = (() => Model.attribute('label'))();
  url = (() => Model.attribute('url'))();
  icon = (() => Model.attribute('icon'))();
  isNewTab = (() => Model.attribute('isNewTab'))();
  isInternal = (() => Model.attribute('isInternal'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  updatedAt = (() => Model.attribute('updatedAt', Model.transformDate))();
}
flarum.reg.add('acpl-mobile-tab', 'common/models/CustomTabItem', CustomTabItem);